import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
export const EbookPreview: React.FC = () => {
  const {
    t
  } = useLanguage();
  return <section className="py-24 bg-white" data-id="element-20">
      <div className="container mx-auto px-6 max-w-5xl text-center" data-id="element-21">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="mb-16" data-id="element-22">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-23">
            {t('preview.title.1')}{' '}
            <span className="text-coral-500 italic" data-id="element-24">
              {t('preview.title.2')}
            </span>
          </h2>
          <p className="text-lg text-gray-600 font-sans max-w-2xl mx-auto" data-id="element-25">
            {t('preview.subtitle')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="relative rounded-3xl overflow-hidden mx-auto max-w-4xl ebook-glow" data-id="element-26">
          <img src="https://cdn.magicpatterns.com/uploads/qbPdWCW2AYKtbYsqZf5Ka5/Behind_the_Scene.png" alt="Contenido del E-book UGC: Intro, Oferta, Portafolio, Scripts, Tarifas, Entrega, Plataformas, Checklist" className="w-full h-auto object-cover" data-id="element-27" />

          {/* Subtle overlay gradient to make it pop */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent pointer-events-none" data-id="element-28"></div>
        </motion.div>
      </div>
    </section>;
};